import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectRouter = state => state.get('router');

const makeSelectLocation = () =>
  createSelector(selectRouter, routerState =>
    routerState.get('location').toJS(),
  );

const selectUser = state => state.get('user', initialState);

const makeSelectUser = () =>
  createSelector(selectUser, userState => userState.get('user'));

const makeSelectTokenValidation = () =>
  createSelector(selectUser, userState => userState.get('invalid'));

const makeSelectFeatures = () =>
  createSelector(selectUser, userState => userState.get('user').features);

const selectMembers = () =>
  createSelector(selectUser, userState => userState.get('members'));

const selectTheme = () =>
  createSelector(selectUser, userState => {
    const user = userState.get('user') || {};
    const preferences = (user.hasOwnProperty('_root') ? user.toJS().preference : user.preference) || [];

    return (
      preferences.find(preference => preference.name === 'theme') || 'default'
    );
  });

const selectErrors = () =>
  createSelector(selectUser, userState =>
    userState.get('errors')
  );

const selectHasErrors = state => errorDomain => {
  if (state && errorDomain) {
    const errors = state.get('user').toJS().errors || {};
    return errors.hasOwnProperty(errorDomain) && Object.keys(errors[errorDomain]).length > 0
  }

  return false;
};

createSelector(selectUser, userState => {
  let errors = userState.get('errors');

  if (errors.hasOwnProperty('_root')) {
    errors = errors.toJS();
  }

  delete errors.member;

  return Object.keys(errors).length > 0;
});

const selectIsLoading = () =>
  createSelector(selectUser, userState => userState.get('loading'));

const featureVisible = state => featureSlug =>
  state
    .get('user')
    .get('user')
    .features.some(
      feature => feature.slug === featureSlug && feature.enabled > 0,
    ) || false;

const featureAllowed = state => featureSlug => {
  const user = state.get('user').get('user');
  const features =
    (user.hasOwnProperty('_root') ? user.toJS().features : user.features) || [];

  return (
    features.some(
      feature => feature.slug === featureSlug && feature.enabled > 1,
    ) || false
  );
};

export {
  selectIsLoading,
  makeSelectLocation,
  makeSelectUser,
  selectTheme,
  makeSelectTokenValidation,
  makeSelectFeatures,
  featureAllowed,
  featureVisible,
  selectErrors,
  selectHasErrors,
  selectMembers,
};
